<section class="content-layout" [brightsideWebFb]="{ event_name: 'find_money_welcome' }">
  <bw-action-article-legacy>
    <ui-nav-exit-back
      back-action-top
      [trackingDetail]="{ event_name: 'find_money_welcome' }"
    ></ui-nav-exit-back>

    <div content-section>
      <div class="flex-column mb-sm">
        <div class="align-left">
          <img src="../assets/savings_hero.svg" alt="savings_hero" class="mb-md" />
          <p title-medium class="mb-sm">{{ 'FIND_MONEY_WELCOME_TITLE' | translate }}</p>
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p class="left" style="max-width: 432px">
              {{ 'FIND_MONEY_WELCOME_DESC' | translate }}
            </p>
          </typography-legacy>

          <div class="mt-md">
            <typography-legacy text-large-semibold class="mb-sm">{{ 'FIND_MONEY_WELCOME_DISCOVER' | translate }}</typography-legacy>
            <div class="flex-row space-between">
              <div class="align-left mr-sm">
                <bw-icon-legacy [iconName]="'checkmark'" size="24"></bw-icon-legacy>
              </div>
              <div class="flex-column flex-item-flexible">
                <typography-legacy text-small-regular>{{ 'FIND_MONEY_WELCOME_1' | translate }}</typography-legacy>
              </div>
            </div>
            <div class="flex-row space-between">
              <div class="align-left mr-sm">
                <bw-icon-legacy [iconName]="'checkmark'" size="24"></bw-icon-legacy>
              </div>
              <div class="flex-column flex-item-flexible">
                <typography-legacy text-small-regular>{{ 'FIND_MONEY_WELCOME_2' | translate }}</typography-legacy>
              </div>
            </div>
            <div class="flex-row space-between">
              <div class="align-left mr-sm">
                <bw-icon-legacy [iconName]="'checkmark'" size="24"></bw-icon-legacy>
              </div>
              <div class="flex-column flex-item-flexible">
                <typography-legacy text-small-regular>{{ 'FIND_MONEY_WELCOME_3' | translate }}</typography-legacy>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div footer-actions>
      <button bw-button-legacy type="submit" [brightsideWebFb]="{ event_name: 'find_money_welcome' }" (click)="getStarted()">
        {{ 'FIND_MONEY_GET_STARTED' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>
